import { Box, Typography } from '@mui/material';

/**
 * A person's initials in a circle — the UI pattern library's avatar (P3's
 * Employee panel, P4's hover card), sized and coloured as the Insights
 * prototype's `tl-avatar` is in lists: 24px, purple-20 with purple-100 text.
 *
 * The Resource planner (`PlannerRow`) and the timeline (`AllocationStack`)
 * draw their own, coloured per person or role and at other sizes; sharing
 * one would change those pages, so Settings keeps this one.
 */
export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0]!.toUpperCase())
    .slice(0, 2)
    .join('');

export const PersonAvatar = ({ name }: { name: string }) => (
  <Box
    aria-hidden
    sx={{
      width: 24,
      height: 24,
      flex: 'none',
      borderRadius: 'var(--border-radius-pill)',
      bgcolor: 'var(--color-purple-20)',
      color: 'var(--color-purple-100)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography variant="label" component="span" sx={{ fontWeight: 500, color: 'inherit' }}>
      {initialsOf(name)}
    </Typography>
  </Box>
);
